import ApplicationController from '../application_controller'
import Packery from 'packery'

const CROSS_DEPARTMENTAL_EXECUTORS = ['team', 'mentor', 'buddy']

class TemplateEntryController extends ApplicationController {
  static targets = [
    'container',
    'sameUnitWrapper',
    'sameUnitCheckbox',
    'crossDepartmentalWrapper',
    'crossDepartmentalCheckbox',
    'executorSelect',
    'optionItem',
    'optionCheckbox',
    'optionsCounter'
  ]

  connect () {
    this.optionCheckboxTargets.forEach((checkbox) => {
      checkbox.addEventListener('change', () => this.updateOptionsCounter())
    })
    this.updateOptionsCounter()

    this.executorSelectTarget.addEventListener('change', (event) => {
      const value = event.target.value

      if (this.hasSameUnitWrapperTarget) {
        if (value.startsWith('team')) {
          this.enableSameUnit()
        } else {
          this.disableSameUnit()
        }
      }

      if (this.hasCrossDepartmentalWrapperTarget) {
        if (this.crossDepartmentalAllowed(value)) {
          this.showCrossDepartmental()
        } else {
          this.hideCrossDepartmental()
        }
      }

      this.updateOptionsCounter()
      this.resizeItems()
    })
  }

  updateOptionsCounter () {
    if (!this.hasOptionsCounterTarget) return

    const visibleItems = this.optionItemTargets.filter((item) => !item.classList.contains('d-none'))
    const checked = visibleItems.filter((item) => item.querySelector('input[type=checkbox]:checked')).length

    this.optionsCounterTarget.textContent = `${checked}/${visibleItems.length}`
  }

  toggleSameUnit (event) {
    if (event.target.checked && this.hasCrossDepartmentalCheckboxTarget) {
      this.crossDepartmentalCheckboxTarget.checked = false
    }
    this.updateOptionsCounter()
  }

  toggleCrossDepartmental (event) {
    if (event.target.checked && this.hasSameUnitCheckboxTarget) {
      this.sameUnitCheckboxTarget.checked = false
    }
    this.updateOptionsCounter()
  }

  crossDepartmentalAllowed (executorValue) {
    const executorType = executorValue.split(':')[0]
    return CROSS_DEPARTMENTAL_EXECUTORS.includes(executorType)
  }

  enableSameUnit () {
    this.sameUnitWrapperTarget.classList.remove('d-none')
    if (this.hasSameUnitCheckboxTarget) this.sameUnitCheckboxTarget.checked = true
    if (this.hasCrossDepartmentalCheckboxTarget) this.crossDepartmentalCheckboxTarget.checked = false
  }

  disableSameUnit () {
    this.sameUnitWrapperTarget.classList.add('d-none')
    if (this.hasSameUnitCheckboxTarget) this.sameUnitCheckboxTarget.checked = false
  }

  showCrossDepartmental () {
    this.crossDepartmentalWrapperTarget.classList.remove('d-none')
  }

  hideCrossDepartmental () {
    this.crossDepartmentalWrapperTarget.classList.add('d-none')
    if (this.hasCrossDepartmentalCheckboxTarget) this.crossDepartmentalCheckboxTarget.checked = false
  }

  resizeItems () {
    const itemsContainer = document.getElementById('boarding_template_entries')
    if (itemsContainer) {
      const grid = new Packery(itemsContainer, {
        itemSelector: '.field',
        percentPosition: true
      })

      grid.layout()
    }
  }
}

export default TemplateEntryController
